// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web — features/financeiro/hooks/useFluxoCaixaGerencial.ts
// ════════════════════════════════════════════════════════════════════════════

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fluxoCaixaGerencialService,
  type ReprocessarParams,
} from '../services/fluxoCaixaGerencialService';

export const useFluxoCaixaGerencial = (dtInicio: string, dtFim: string) =>
  useQuery({
    queryKey: ['fluxo-caixa-gerencial', dtInicio, dtFim],
    queryFn: () => fluxoCaixaGerencialService.obter(dtInicio, dtFim),
    enabled: !!(dtInicio && dtFim),
  });

export const useFluxoCaixaGerencialReprocesso = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: ReprocessarParams) => fluxoCaixaGerencialService.reprocessar(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fluxo-caixa-gerencial'] });
      queryClient.invalidateQueries({ queryKey: ['fluxo-caixa-gerencial-detalhe'] });
    },
  });
};

export interface ContaDetalheRef {
  contaId: number;
  gerencial: boolean;
}

export const useFluxoCaixaGerencialDetalhe = (
  conta: ContaDetalheRef | null,
  dtInicio: string,
  dtFim: string,
) =>
  useQuery({
    queryKey: ['fluxo-caixa-gerencial-detalhe', conta?.contaId, conta?.gerencial, dtInicio, dtFim],
    queryFn: () =>
      fluxoCaixaGerencialService.detalhe(conta!.contaId, conta!.gerencial, dtInicio, dtFim),
    enabled: conta != null && !!(dtInicio && dtFim),
  });
